// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetSubscriptionsListRequest,
  TGetSubscriptionsListModel,
  IMappers,
  TGetSubscriptionsListResponse,
  IGetSubscriptionsListResponse,
  IGetSubscriptionsListResponseError,
} from './types';

export const defaultConfig: TGetSubscriptionsListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'subscriptions',
  pathApi: '/v1/get-subscriptions-list/',
  responseType: 'json',
} as TGetSubscriptionsListModel;

export function createGetSubscriptionsListModel(parameters: IGetSubscriptionsListRequest): TGetSubscriptionsListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetSubscriptionsListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetSubscriptionsListRequest;
}

export async function fetchGetSubscriptionsList<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetSubscriptionsListOptions<TResponse200, TResponse400>): Promise<
  TGetSubscriptionsListResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createGetSubscriptionsListModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetSubscriptionsListResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetSubscriptionsListResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetSubscriptionsListResponse;
}
